import { FC, SVGAttributes } from 'react';

const EyesOpen: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9996 8.10059C9.8457 8.10059 8.09961 9.84668 8.09961 12.0006C8.09961 14.1545 9.8457 15.9006 11.9996 15.9006C14.1535 15.9006 15.8996 14.1545 15.8996 12.0006C15.8996 9.84668 14.1535 8.10059 11.9996 8.10059ZM9.89961 12.0006C9.89961 10.8408 10.8398 9.90059 11.9996 9.90059C13.1594 9.90059 14.0996 10.8408 14.0996 12.0006C14.0996 13.1604 13.1594 14.1006 11.9996 14.1006C10.8398 14.1006 9.89961 13.1604 9.89961 12.0006Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.10059C5.42888 4.10059 2.14273 9.7214 1.38249 11.2086C1.12641 11.7096 1.12641 12.2916 1.38249 12.7926C2.14273 14.2798 5.42888 19.9006 12 19.9006C18.5712 19.9006 21.8574 14.2798 22.6176 12.7926C22.8737 12.2916 22.8737 11.7096 22.6176 11.2086C21.8574 9.7214 18.5712 4.10059 12 4.10059ZM12 18.1006C6.5904 18.1006 3.75535 13.4687 2.99924 12.0006C3.75535 10.5325 6.5904 5.90059 12 5.90059C17.4097 5.90059 20.2447 10.5325 21.0008 12.0006C20.2447 13.4687 17.4097 18.1006 12 18.1006Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EyesOpen;
